import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import * as serviceWorker from './serviceWorker';

import 'bootstrap/scss/bootstrap.scss';
import '@mdi/font/scss/materialdesignicons.scss';
import './index.scss';
import './App.scss';
import store from './store';
import App from './App';
import { history } from './store/reducers';

console.info('VERSION ' + process.env.REACT_APP_VERSION);
console.info('LAST UPDATE: 08/03/2020 17:15');
if (process.env.REACT_APP_ENV === 'staging' || process.env.REACT_APP_ENV === 'development') {
  document.title = 'Zebra Sports Edge || ' + process.env.REACT_APP_VERSION;
}
console.info('env', process.env.REACT_APP_ENV);

ReactDOM.render(<Provider store={store}>
  <ConnectedRouter history={history}>
    <App />
  </ConnectedRouter>
</Provider>, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
